<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm
            ref="quickLeadUpdateForm"
            @submit="submitForm($event, 'quickLeadUpdateForm')"
        >
            <CTabs variant="tabs" :active-tab="0">
                <!--  Tab General -->
                <CTab
                    :title="tagsById[key].name"
                    v-for="(field, key) in fieldsGroupedByTag"
                    :key="key"
                >
                    <CContainer>
                        <CRow
                            v-for="(field, index) in fieldsGroupedByTag[key]"
                            :key="index"
                        >
                            <CCol>
                                <CSelect
                                    v-if="
                                        field._field &&
                                        field._field.type == 'options'
                                    "
                                    :name="field._field.code"
                                    :placeholder="$t('-- Select an option --')"
                                    :options="field._field.optionsAsArray"
                                    :value.sync="
                                        forms.quickLeadUpdateForm[
                                            field._field.code
                                        ]
                                    "
                                    :label="field._field.nameAsLabel"
                                    size="sm"
                                />
                                <CCSwitch
                                    v-else-if="
                                        field._field &&
                                        field._field.type == 'boolean'
                                    "
                                    :checked.sync="
                                        forms.quickLeadUpdateForm[
                                            field._field.code
                                        ]
                                    "
                                    :label="field._field.nameAsLabel"
                                    :name="field._field.code"
                                    color="primary"
                                    shape="pill"
                                    variant="3d"
                                    size="sm"
                                />

                                <DatePicker
                                    v-else-if="
                                        field._field &&
                                        field._field.type == 'date'
                                    "
                                    v-model="
                                        forms.quickLeadUpdateForm[
                                            field._field.code
                                        ]
                                    "
                                    :masks="{
                                        input: 'YYYY-MM-DD',
                                    },"
                                >
                                    <template
                                        v-slot="{ inputValue, inputEvents }"
                                    >
                                        <CInput
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            :label="field._field.nameAsLabel"
                                            :placeholder="
                                                field._field.nameAsLabel
                                            "
                                            :name="field._field.code"
                                            size="sm"
                                        />
                                    </template>
                                </DatePicker>

                                <CInput
                                    v-else
                                    :value.sync="
                                        forms.quickLeadUpdateForm[
                                            field._field.code
                                        ]
                                    "
                                    :name="field._field.code"
                                    :label="field._field.nameAsLabel"
                                    :disabled="
                                        reservedFields.includes(
                                            field._field.code
                                        )
                                    "
                                    size="sm"
                                />
                            </CCol>
                        </CRow>
                    </CContainer>
                </CTab>
            </CTabs>
            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.quickLeadUpdateForm._loading"
            >
                <span>{{ $t("send") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading
                color="primary"
                @click="executeSubmitForm('quickLeadUpdateForm')"
                :loading="forms.quickLeadUpdateForm._loading"
            >
                {{ $t("send") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
/** Components */
import ButtonLoading from "~/components/ButtonLoading.vue";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

/** Mixins */
import formMixin from "~/mixins/form";
import modalComponentMixin from "~/mixins/modalComponent";

/** Others */
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { snakeToCamel } from "../../../../utils";
import { snakeToSpace } from "../../../../utils";
import CCSwitch from "~/components/CCSwitch.vue";
export default {
    name: "QuickLeadUpdateModal",
    mixins: [formMixin, validationMixin, modalComponentMixin],
    components: {
        ButtonLoading,
        CCSwitch,
        Calendar,
        DatePicker,
    },
    data() {
        return {
            forms: {
                quickLeadUpdateForm: {
                    firstName: null,
                    lastName: null,
                    _loading: false,
                },
            },
            fields: [],
            tags: [],
            tagsById: {},
            fieldsGroupedByTag: {},
            reservedFields: [
                "email",
                "phone",
                "ip",
                "url1party",
                "timestamp1party",
            ],

            preferentSortByCodes: [
                "email",
                "phone",
                "ip",
                "url1party",
                "timestamp1party",
                "firstName",
                "lastName",
                "genre",
                "birthDate",
                "cp",
                "catastalCode",
                "province",
                "address",
                "acceptPrivacyPolicy1party",
                "acceptPrivacyPolicy2party",
                "acceptPrivacyPolicy3party",
            ],
            providerId: null,
            leadId: null,
        };
    },
    props: {
        provider: {
            required: true, // Provider Uuid
        },
    },
    validations: {
        forms: {
            quickLeadUpdateForm: {
                firstName: {
                    required,
                },
                lastName: {
                    required,
                },
            },
        },
    },

    watch: {
        dataComponent() {
            this.forms.quickLeadUpdateForm = {
                ...this.forms.quickLeadUpdateForm,
                ...this.dataComponent.lead,
            };
        },
    },

    methods: {
        async loadProviderFields() {
            const resp = await this.fetcher({
                url: `/input.api/providers/${this.provider}/fields`,
            });

            this.fields = resp._items;
        },
        async loadTags() {
            const resp = await this.fetcher({
                baseURL: process.env.VUE_APP_API_CORE,
                url: "/tags",
            });

            this.tags = resp._items;
            this.tagsById = {};
            for (let i = 0; i < this.tags.length; i++) {
                const tag = this.tags[i];
                this.tagsById = {
                    ...this.tagsById,
                    [tag.id]: tag,
                };
            }
        },
        async loadFields() {
            const listIds = this.fields.map((field) => {
                return field.field_id;
            });

            const resp = await this.fetcher({
                baseURL: process.env.VUE_APP_API_CORE,
                url: "/fields",
                query: {
                    query: {
                        where: {
                            id: {
                                in: listIds,
                            },
                        },
                    },
                },
            });

            this.fields = this.fields.map((field) => {
                const find = resp._items.find(
                    (item) => item.id == field.field_id
                );

                const adapterFind = {
                    code: snakeToCamel(find.code),
                    tagId: find.tagId,
                    nameAsLabel: snakeToSpace(find.name),
                    codeAsLabel: snakeToSpace(find.code),
                    optionsAsArray: find.options
                        ? find.options.replaceAll("\n", "").split(",")
                        : [],
                    type: find.type,
                };

                return {
                    ...field,
                    _field: adapterFind,
                };
            });
            // .filter((field) => {
            //     return !this.reservedFields.includes(field._field.code);
            // });
            this.fields = this.sortByCode(
                this.fields,
                this.preferentSortByCodes,
                "_field.code"
            );

            for (let i = 0; i < this.fields.length; i++) {
                const field = this.fields[i];

                if (!this.fieldsGroupedByTag[field._field.tagId]) {
                    this.fieldsGroupedByTag = {
                        ...this.fieldsGroupedByTag,
                        [field._field.tagId]: [],
                    };
                }

                this.fieldsGroupedByTag[field._field.tagId].push(field);
            }
        },

        sortByCode(fieldsArray, codesArray, fieldCodeName = "code") {
            // Función para obtener dinámicamente el valor del código desde el nombre del campo
            function getValue(obj, fieldCodeName) {
                // Separa el fieldCodeName por puntos para navegar en las propiedades anidadas
                const propiedades = fieldCodeName.split(".");
                // Usa reduce para recorrer las propiedades anidadas del objeto
                return propiedades.reduce((valor, prop) => {
                    return valor ? valor[prop] : undefined;
                }, obj);
            }

            // Creamos un mapa de orden basado en el codesArray
            const orderMap = {};
            codesArray.forEach((code, index) => {
                orderMap[code] = index;
            });

            // Ordenamos el array de fields en función del code que obtenemos del fieldCodeName
            return fieldsArray.sort((a, b) => {
                const codeA = getValue(a, fieldCodeName);
                const codeB = getValue(b, fieldCodeName);

                // Buscamos las posiciones en el orderMap
                const orderA =
                    orderMap[codeA] !== undefined
                        ? orderMap[codeA]
                        : Number.MAX_VALUE;
                const orderB =
                    orderMap[codeB] !== undefined
                        ? orderMap[codeB]
                        : Number.MAX_VALUE;

                return orderA - orderB;
            });
        },
        async submitForm(e, formName) {
            e.preventDefault();
            // this.$v.forms.quickLeadUpdateForm.$touch();
            try {
                // if (this.$v.forms.quickLeadUpdateForm.$invalid) {
                //     throw { code: 422, message: this.$t("Invalid data") };
                // }

                this.forms.quickLeadUpdateForm._loading = true;
                const form = this.$refs.quickLeadUpdateForm;
                const formData = new FormData(form);
                let data = Object.fromEntries(formData.entries());
                form.querySelectorAll('input[type="checkbox"]').forEach(
                    (checkbox) => {
                        data[checkbox.name] = checkbox.checked; // Convertimos "on"/"off" a true/false
                    }
                );

                // console.log({ dataBefore: { ...data } });

                for (const key in data) {
                    if (Object.prototype.hasOwnProperty.call(data, key)) {
                        if (data[key] == "") {
                            data[key] = null;
                        }
                    }
                }

                // console.log({ dataAfter: { ...data } });
                const response = await this.fetcher({
                    method: "PATCH",
                    baseURL: process.env.VUE_APP_API_SASS,
                    url: `/input-campaign/${this.provider}/leads/${this.dataComponent.lead.id}/quick-update`,
                    data: data,
                });

                this.showMessageSuccess();
                this.showComponent = false;

                this.$emit("submit", formName);
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.forms.quickLeadUpdateForm._loading = false;
            }
        },
    },
    async mounted() {
        await this.loadTags();
        await this.loadProviderFields();
        await this.loadFields();
    },
};
</script>
